export default "__VITE_ASSET__7VWDEO4r__"